module.exports = __webpack_public_path__ + "img/people.400be02c.svg";